import $ from "jquery";

document.addEventListener('DOMContentLoaded', function() {

    const header = $( '.js-sticky-header' );
    const headerOffset = header.outerHeight() + 50;

    $( window ).on('scroll', function( event ){
        let scrollTop = $( this ).scrollTop();

        if ( scrollTop > headerOffset ) {
            header.addClass( 'header-sticky' );
        } else {
            header.removeClass( 'header-sticky' );
        }
    })

});